import { createAction } from 'redux-actions';
import * as actionType from './actionTypes';

const setNextPath = createAction(actionType.SET_NEXT_PATH);
const clearNextPath = createAction(actionType.CLEAR_NEXT_PATH);

export { setNextPath, clearNextPath };
